<template>
    <v-main>
      <ChannelsHero/>
      <ChannelsSMS/>
      <ChannelsMMS/>
      <ChannelsVoice/>
      <ChannelsEmail/>
      <ChannelsChat/>

    </v-main>
</template>
  
<script>
import ChannelsHero from './ChannelsHero.vue'
import ChannelsSMS from './ChannelsSMS.vue'
import ChannelsMMS from './ChannelsMMS.vue'
import ChannelsVoice from './ChannelsVoice.vue'
import ChannelsEmail from './ChannelsEmail.vue'
import ChannelsChat from './ChannelsChat.vue'

export default {
  name: 'ChannelsPage',
  components: {
    ChannelsHero,
    ChannelsSMS,
    ChannelsMMS,
    ChannelsVoice,
    ChannelsEmail,
    ChannelsChat

  },
}
</script>